import React from 'react';
import '../assets/css/style.css';
import img from '../assets/css/img/count1.png';
import img2 from '../assets/css/img/count2.png';

const BottomCard = () => {
  return (
    <div className="bottom-card container">
      <div className="row">
        <div className="col-12 col-md-4  justify-content-center align-items-center card-item">
          <img src={img} alt="Trusted Years" />
          <div>
            <h2>10+</h2>
            <p>Trusted Years</p>
          </div>
        </div>
        <div className="col-12 col-md-4  justify-content-center align-items-center card-item">
          <img src={img2} alt="KW Installed" />
          <div>
            <h2>7MW+</h2>
            <p>KW Installed</p>
          </div>
        </div>
        <div className="col-12 col-md-4  justify-content-center align-items-center card-item">
          <img src={img2} alt="Completed Projects" />
          <div>
            <h2>500+</h2>
            <p>Completed Projects</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BottomCard;


